import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ImagesState {
  imagesData: any;
  // ... other state properties
}

const initialState: ImagesState = {
  imagesData: {},
  // ... other initial state
};

const imagesSlice = createSlice({
  name: 'images',
  initialState,
  reducers: {
    setImagesData: (state, action: PayloadAction<any>) => {
      state.imagesData = action.payload;
    },
    // ... other reducers
  }
});

export const { setImagesData } = imagesSlice.actions;
export default imagesSlice.reducer; 